export const courses = [
  {
    id: "1f4b0d97-7bcd-4a68-8dd9-fe39cb898964",
    title: "KHÓA HỌC LÁI XE Ô TÔ SỐ TỰ ĐỘNG – HẠNG B (BD)",
    slug: "khóa-học-b1",
    image: "classB1",
    price_origin: 25000000,
    price: 22900000,
    short_desc: `Khóa học lái xe ô tô hạng B1 (BD) được thiết kế dành riêng cho người không hành nghề lái xe, phù hợp với:

Người lái xe cá nhân, gia đình

Người mới bắt đầu, chưa từng cầm vô lăng

Học viên có nhu cầu thi lái xe số tự động thay vì số sàn`,
    content_md: `# **Dành cho người mới – Học dễ – Lái vững – Thi là đậu!**

Khóa học bao gồm **lý thuyết, thực hành, thi thử** và **hỗ trợ toàn bộ hồ sơ, quy trình thi sát hạch**.

---

## 📘 **1. Lý thuyết – Học dễ, hiểu nhanh**

- Luật giao thông đường bộ mới nhất  
- Biển báo giao thông, vạch kẻ đường  
- Kỹ năng xử lý tình huống giao thông thực tế  
- Cấu tạo và nguyên lý hoạt động cơ bản của ô tô  
- 60 câu hỏi điểm liệt – Cách học để tránh sai sót  
- Cung cấp tài liệu + ứng dụng luyện thi trên điện thoại  

---

## 🚘 **2. Thực hành lái xe – Luyện kỹ năng thực tế**

- Làm quen với xe số tự động đời mới (Toyota Vios, Hyundai,...)  
- Thực hành lái xe trong sa hình chuẩn Sở GTVT:  
      - Đề-pa dốc cầu  
      - Dừng, khởi hành, ghép xe, quay đầu, đường vòng,...  
- Lái xe trên đường trường – tình huống thực tế  
- Hướng dẫn kỹ thuật quan sát, đánh lái, căn chỉnh, xử lý nhanh  
- Học 1 kèm 1 với giáo viên, điều chỉnh theo trình độ  

---

## 📝 **3. Thi thử & hỗ trợ thi thật**

- Thi thử định kỳ trên sân thi thật để làm quen tâm lý  
- Hướng dẫn quy trình nộp hồ sơ, khám sức khỏe, thủ tục đăng ký  
- Tư vấn chọn lịch thi phù hợp với công việc  
- Hướng dẫn thi thật từ A-Z đến khi có bằng  

---

## 🎯 **Kết quả sau khóa học**

- Làm chủ kỹ năng lái xe số tự động an toàn, đúng luật  
- Tự tin tham gia giao thông trong thành phố & đường dài  
- Vượt qua kỳ thi sát hạch cấp bằng lái B1 lần đầu  
- Nhận bằng B1 (BD) hợp pháp, thời hạn **suốt đời**  

---

## ✅ **Ưu điểm khóa học**

- Xe tập đời mới, số tự động, có máy lạnh  
- Học linh hoạt theo ca: sáng, chiều, tối, cuối tuần  
- Giáo viên thân thiện, nhiệt tình, dạy đúng trình độ  
- Cam kết đồng hành đến khi đậu – không phát sinh chi phí ẩn  

---

## 📌 **Thông tin thêm**

- **Thời lượng học:** Tùy theo năng lực & thời gian của học viên (từ 1–2 tháng)  
- **Học phí:** Gọi/Zalo để được tư vấn chi tiết & nhận ưu đãi nhóm  
- **Địa điểm:** 60/12B Đ Lồ Ô, Phường Đông Hòa, Thành phố Hồ Chí Minh, Việt Nam  
- **Liên hệ đăng ký:** 078 652 9313 (Zalo/Call)  

---

# 🎓 "Học thật – Lái thật – Thi là đậu – Có bằng suốt đời!"`
  },

  {
    id: "18e141c7-716f-40fa-b896-76340e89b4e3",
    title: "KHÓA ĐÀO TẠO LÁI XE Ô TÔ SỐ SÀN – HẠNG B (BS)",
    slug: "khóa-học-b2",
    image: "classB2",
    price_origin: 25000000,
    price: 22900000,
    short_desc: `Khóa đào tạo lái xe ô tô số sàn hạng B (BS) giúp bạn nắm vững luật giao thông, thành thạo kỹ năng lái xe số sàn an toàn và tự tin, đồng thời được hỗ trợ đầy đủ quy trình thi sát hạch để nhanh chóng lấy bằng lái hợp pháp.`,
    content_md: `# 🚗 **KHÓA ĐÀO TẠO LÁI XE Ô TÔ SỐ SÀN – HẠNG B (BS)**

Dành cho ai muốn làm chủ kỹ năng lái xe số sàn, an toàn – tự tin – nhanh chóng lấy bằng!

Khóa học tổng hợp **lý thuyết chuyên sâu, thực hành kỹ năng điều khiển xe số sàn**, thi thử & hỗ trợ tối đa các thủ tục thi sát hạch.

---

## 📘 **1. Lý thuyết giao thông – Nắm chắc luật, vững tâm lý**

- Luật giao thông đường bộ mới nhất và các quy định liên quan  
- Biển báo, vạch kẻ đường, hiệu lệnh của cảnh sát giao thông  
- Kỹ năng xử lý các tình huống giao thông phức tạp  
- Câu hỏi điểm liệt & mẹo tránh sai sót khi thi lý thuyết  
- Tài liệu ôn tập + phần mềm luyện thi trên điện thoại  

---

## 🚦 **2. Thực hành lái xe số sàn – Làm chủ kỹ thuật**

- Làm quen xe số sàn đời mới, điều khiển xe trơn tru, chính xác  
- Luyện tập sa hình chuẩn Sở GTVT với đầy đủ bài tập thực tế:  
      - Đề-pa dốc  
      - Lùi chuồng  
      - Ghép xe song song  
      - Quay đầu xe  
      - Đường vòng  
- Kỹ thuật quan sát, xử lý nhanh, kỹ năng giữ xe ổn định trên mọi địa hình  
- Lái xe đường trường – ứng phó tình huống ngoài thực tế  
- Học 1 kèm 1, giáo viên tận tình hướng dẫn và chỉnh sửa kỹ thuật phù hợp trình độ  

---

## 📝 **3. Thi thử & hỗ trợ thi thật**

- Tổ chức thi thử sát hạch thực tế giúp học viên tự tin khi bước vào kỳ thi chính thức  
- Hướng dẫn quy trình nộp hồ sơ, khám sức khỏe, đăng ký thi  
- Tư vấn lịch thi phù hợp với cá nhân và công việc  
- Hỗ trợ hoàn thiện thủ tục, nhận bằng nhanh chóng sau khi đậu  

---

## 🎯 **LỢI ÍCH SAU KHÓA HỌC**

- Tự tin điều khiển xe số sàn an toàn và đúng luật giao thông  
- Nắm vững kỹ thuật lái xe chuyên nghiệp, xử lý tình huống thành thạo  
- Vượt qua kỳ thi sát hạch cấp bằng lái B (số sàn) ngay lần đầu  
- Nhận bằng lái hợp pháp, thời hạn sử dụng dài hạn, giá trị trên toàn quốc  

---

## ✅ **ƯU ĐIỂM KHÓA HỌC**

- Xe tập số sàn đời mới, đảm bảo an toàn, vận hành mượt mà  
- Lịch học linh hoạt: sáng, chiều, tối, cuối tuần phù hợp mọi đối tượng  
- Đội ngũ giáo viên giàu kinh nghiệm, tận tâm, sẵn sàng hỗ trợ đến khi đậu  
- Cam kết không phát sinh chi phí ẩn, đồng hành đến khi học viên nhận bằng  

---

## 📌 **THÔNG TIN LIÊN HỆ**

- **Thời lượng học:** Từ 1 – 3 tháng tùy theo năng lực và thời gian học viên  
- **Học phí:** Liên hệ để nhận tư vấn và ưu đãi nhóm  
- **Địa điểm:** 60/12B Đ Lồ Ô, Phường Đông Hòa, Thành phố Hồ Chí Minh, Việt Nam  
- **Liên hệ đăng ký:** 078 652 9313 (Zalo/Call)  

---

# 🎓 **"Học lái xe số sàn – Vững tay lái – Tự tin trên mọi nẻo đường!"**
`
  },

  {
    id: "18436667-fbc9-4be1-bc13-36f9d490dda8",
    title: "KHÓA HỌC LÁI XE MÁY A1",
    slug: "khóa-học-a1",
    image: "classA1",
    price_origin: 800000,
    price: 700000,
    short_desc: `Đào tạo & ôn luyện thi sát hạch lái xe mô tô hạng A1 (xe máy ≤125cc)
Hướng dẫn chi tiết lý thuyết + thực hành
Cam kết thi đậu ngay lần đầu, hỗ trợ thi thử, luyện thi 1-1
Phù hợp cho học viên mới bắt đầu, chưa từng lái xe.`,
    content_md: `## 📘 **1. Học lý thuyết – Nắm vững luật, tránh điểm liệt**

- 📖 Ôn luyện 100 câu hỏi chuẩn của Bộ GTVT  
- 🚦 Nhận biết biển báo giao thông & vạch kẻ đường  
- 🧠 Học cách xử lý tình huống thực tế an toàn  
- ❗ Làm chủ các câu hỏi điểm liệt – tránh rớt oan uổng  
- ✅ Cung cấp mẹo làm bài, ứng dụng luyện thi miễn phí  

---

## 🛵 **2. Thực hành lái xe – Làm chủ tay lái, tự tin thi thật**

- 🔄 Hướng dẫn chạy sa hình chuẩn của Sở GTVT  
- 8️⃣ Luyện kỹ năng vòng số 8, đường hẹp, đường gồ ghề  
- ⚖️ Hướng dẫn cách giữ thăng bằng, giữ ga – vào số mượt  
- 🧑‍🏫 Giáo viên hướng dẫn 1 kèm 1 – sửa lỗi ngay tại chỗ  
- 🚗 Có sẵn xe tập tại trung tâm – không cần xe riêng  

---

## 📝 **3. Thi thử & hỗ trợ thi thật – Tự tin vượt qua kỳ thi**

- 🧪 Thi thử định kỳ như thi thật – luyện tâm lý & kỹ năng  
- 🧾 Hướng dẫn chi tiết quy trình thi, thủ tục đăng ký  
- 📂 Hỗ trợ chuẩn bị hồ sơ, nộp lệ phí, nhận GPLX sau thi  
- 📸 Tư vấn ảnh & giấy tờ đúng chuẩn theo quy định Bộ GTVT  
- 🎯 Cam kết đồng hành đến khi bạn thi đậu`
  },

  {
    id: "9d35311b-8664-4b90-8e5b-421032e1c5dd",
    title: "KHÓA HỌC LÁI XE MÔ TÔ PHÂN KHỐI LỚN (HẠNG A2)",
    slug: "khóa-học-a2",
    image: "classA2",
    price_origin: 2000000,
    price: 1800000,
    short_desc: `Khóa học lái xe hạng A2 dành cho học viên từ 18 tuổi trở lên, có nhu cầu sở hữu bằng lái mô tô phân khối lớn (trên 125cc). Chương trình được thiết kế chuẩn theo quy định của Bộ GTVT`,
    content_md: `# 🏍️ **KHÓA HỌC LÁI XE MÔ TÔ PHÂN KHỐI LỚN – HẠNG A**  
# Làm chủ xe mô tô >125cc – Thi dễ, đậu nhanh – Có bằng hợp pháp!

---

## 📘 **1. Lý thuyết – Ôn tập thông minh, nắm chắc 100 câu hỏi**

- 📚 Ôn luyện 100 câu hỏi sát hạch chuẩn của Bộ GTVT  
- 🚸 Hệ thống đầy đủ biển báo, vạch kẻ đường & luật giao thông mới nhất  
- ❗ Tập trung vào các câu hỏi điểm liệt dễ sai – hướng dẫn cách làm đúng  
- 🧠 Luyện kỹ năng phán đoán & xử lý tình huống nguy hiểm thực tế  
- 📱 Học qua app & tài liệu online – phù hợp người bận rộn  

---

## 🏍️ **2. Thực hành mô tô phân khối lớn – Làm chủ xe “hạng nặng”**

- 🛣️ Hướng dẫn điều khiển xe mô tô >175cc an toàn & đúng kỹ thuật  
- 8️⃣ Thực hành vòng số 8, đường hẹp, gồ ghề, leo dốc & xuống dốc  
- ⚖️ Kỹ thuật giữ thăng bằng, kết hợp côn – ga – số – phanh hiệu quả  
- 🧑‍🏫 Hướng dẫn 1 kèm 1 với giáo viên giàu kinh nghiệm xe PKL  
- 🛵 Có sẵn xe phân khối lớn tại sân tập – không cần tự chuẩn bị xe  

---

## 📝 **3. Thi thử & hỗ trợ sát hạch – Đậu ngay lần đầu**

- 🧪 Thi thử sát hạch với xe thực tế & sân tiêu chuẩn giống thi thật  
- 🧾 Hướng dẫn chi tiết quy trình đăng ký, thủ tục thi, hồ sơ cần chuẩn bị  
- 📂 Hỗ trợ học viên từ A-Z: từ ôn thi đến khi nhận bằng A2  
- 📸 Tư vấn ảnh, giấy khám sức khỏe & giấy tờ đúng chuẩn Bộ GTVT  
- 🎯 Cam kết học viên hiểu – thi được – đậu thật  

---

## 🎯 **Sau khóa học bạn sẽ:**

- ✅ Làm chủ kỹ năng điều khiển mô tô phân khối lớn an toàn & đúng luật  
- ✅ Vượt qua sát hạch lý thuyết & thực hành dễ dàng  
- ✅ Nhận bằng lái xe hạng A (A2) hợp pháp, có giá trị toàn quốc  
- ✅ Tự tin tham gia các hoạt động mô tô, phượt đường dài, hội nhóm PKL  

---
`
  }
];